import { ROLES } from '@utils/roleUtils';

export function resolveNeedsCosignForRoles(
  selectedRoles: ReadonlySet<string>,
  needsCosign: boolean,
): boolean {
  return selectedRoles.has(ROLES.CLINICAL_STAFF) || needsCosign;
}
